// Reporting Page Actions

import { reportingPageInitialState } from "./uiLandingPageReportingPageState";

export const makeReportingPageActions = (set, get) => ({
  // Tab management
  setActiveTab: (tab) =>
    set((s) => ({
      reportingPage: { ...s.reportingPage, activeTab: tab },
    })),

  // Report type selection
  setSelectedReportType: (reportType) => {
    set((s) => ({
      reportingPage: {
        ...s.reportingPage,
        selectedReportType: reportType,
        filterSectionVisible: !!reportType,
        filterSectionAnimating: true,
        filters: {
          ...s.reportingPage.filters,
          // Reset unit_cost-only options if switching away from unit_cost
          splitMonth:
            reportType === "unit_cost"
              ? s.reportingPage.filters.splitMonth
              : false,
          includeOverheadProjects:
            reportType === "unit_cost"
              ? s.reportingPage.filters.includeOverheadProjects
              : false,
          org: reportType === "timesheet" ? s.reportingPage.filters.org : "",
        },
      },
    }));

    // Reset animation state after animation completes
    setTimeout(() => {
      set((s) => ({
        reportingPage: {
          ...s.reportingPage,
          filterSectionAnimating: false,
        },
      }));
    }, 1000);
  },

  // Filter management
  updateFilter: (filterUpdates) =>
    set((s) => ({
      reportingPage: {
        ...s.reportingPage,
        filters: {
          ...s.reportingPage.filters,
          ...filterUpdates,
        },
      },
    })),

  clearFilters: () =>
    set((s) => ({
      reportingPage: {
        ...s.reportingPage,
        filters: {
          delStatus: "",
          delStatusLabel: "",
          createdStartDate: "",
          createdEndDate: "",
          delStartDate: "",
          delEndDate: "",
          submitStartDate: "",
          submitEndDate: "",
          approvalStartDate: "",
          approvalEndDate: "",
          projectNumber: "",
          projectLabel: "",
          phase: "",
          phaseLabel: "",
          projectPhaseList: [],
          projectManager: "",
          projectManagerName: "",
          invoiceManager: "",
          invoiceManagerName: "",
          createdBy: "",
          createdByName: "",
          approvedBy: "",
          approvedByName: "",
          splitMonth: false,
          includeOverheadProjects: false,
          org: "",
        },
        filterPhaseList: [],
      },
    })),

  // Phase list management
  setFilterPhaseList: (phaseList) =>
    set((s) => ({
      reportingPage: { ...s.reportingPage, filterPhaseList: phaseList },
    })),

  // Task management
  setCurrentTaskId: (taskId) =>
    set((s) => ({
      reportingPage: {
        ...s.reportingPage,
        currentTaskId: taskId,
        taskStatus: "pending",
        taskError: null,
      },
    })),

  setTaskStatus: (status) =>
    set((s) => ({
      reportingPage: { ...s.reportingPage, taskStatus: status },
    })),

  setTaskError: (error) =>
    set((s) => ({
      reportingPage: {
        ...s.reportingPage,
        taskError: error,
        taskStatus: "failed",
      },
    })),

  clearTask: () =>
    set((s) => ({
      reportingPage: {
        ...s.reportingPage,
        currentTaskId: null,
        taskStatus: null,
        taskError: null,
      },
    })),

  // Reset entire reporting page state
  resetReportingPage: () => set({ reportingPage: reportingPageInitialState }),
});
